import { createAction, handleActions } from 'redux-actions';
import i18next from 'i18next';

import { TYPE, MESSAGE, URL } from '../constant';
import { appKillFunc, hideLoading, hideSplash, localeMessage, logoutRemoveStorage, translationKoMsg } from '../utils/utilityEtc';

// 모든 내용 초기화
const INITIALIZE = 'msg/INITIALIZE';
const ERROR_MESSAGE = 'msg/ERROR_MESSAGE';

// 초기화 action
export const initial = createAction(INITIALIZE);
export const errorMessage = createAction(
  ERROR_MESSAGE,
  (code, message, func, info, msgCode) => ({ code, message, func, info, msgCode})
);

const initialState = {
  errorCode: null,
  errorMessage: null,
  errorFunc: null,
  isDuplicate: false,
};

const error = handleActions(
  {
    [INITIALIZE]: state => initialState,
    [ERROR_MESSAGE]: (state, { payload: error }) => {
      const userInfo = error?.info;
      let msg = error?.message;
      // let code = error?.code;
      let func = error?.func;
      let isDuplicate = false;

      switch (error.code) {
        case TYPE.LOGIN.DUPLICATE:
          msg = localeMessage(MESSAGE.CONCURRENT);
          func = (info) => {
            appKillFunc(info);
            logoutRemoveStorage();
          }
          // code = TYPE.LOGIN.DUPLICATE;
          isDuplicate = true;
          break;
        case TYPE.LOGIN.EXPIRES:
          msg = localeMessage(MESSAGE.TIME_OUT);
          // code = TYPE.LOGIN.EXPIRES;
          func = (info) => appKillFunc(info)
          break;
        case 'NETWORK_ERROR': 
          msg = localeMessage(MESSAGE.NETWORK_ERROR);
          // code = 'NETWORK_ERROR';
          break;
        case 'E000018':
          msg = localeMessage(MESSAGE.TIME_OUT);
          // code = 'E000018';
          func = () => window.location = URL.ACCOUNT.LOGIN
          break;
        case 'E404':
        case 'E500':
          msg = localeMessage(msg);
          func = (info) => appKillFunc(info);
          break;
        case 'S001007':
          msg = i18next.t("API_ERROR.S001007").replace(/\\n/gi, "</br>");
          func = (info) => appKillFunc(info);
          break;
        case 'E000021':
        case 'E000013':
        case 'S003001':
          msg = localeMessage(MESSAGE.INTERNAL_SERVER_ERROR);
          func = (info) => appKillFunc(info);
          break;
        case 'E000022':
          hideSplash();
          hideLoading();
          msg = '앱을 업데이트 해주세요.';
          func = (info) => appKillFunc(info);
          break;
        case 'S003003':
          hideLoading()

          msg = userInfo?.entryType === TYPE.CHANNEL.GLOBAL01 ? i18next.t("API_ERROR.S001006")  : MESSAGE.END_OF_STUDY;
          if (userInfo?.entryType !== TYPE.CHANNEL.GLOBAL01) {
            func = () => {
              if (userInfo?.entryType === TYPE.ENTRY_TYPE.GM_APP) {
                if (window.location.pathname !== URL.ACCOUNT.LOGIN) {
                  window.location = `${URL.ACCOUNT.LOGIN}?LAUNCH_TYPE=GM_APP&CHN_CD=BRS1000`
                }
              } else {
                appKillFunc();
              }
            }
          }
          break;
        case 'S001005': 
        case 'S002012':
          const pathname = window.location.pathname;
          if (!msg) {
            msg = userInfo?.entryType === TYPE.CHANNEL.GLOBAL01 ? i18next.t("API_ERROR.S001005") : translationKoMsg('S001005');
          }
                    
          if (pathname !== URL.ACCOUNT.PW_INQUIRY) {
            func = () => appKillFunc();
          }
          
          break;
        case 'AbortError': 
          msg = localeMessage(MESSAGE.NETWORK_ERROR);
          break;
        case 'msg':
          if (!error.message) break;
          msg = error.message;
          func = error?.func;
          break;
        default:
          if (!error.message) break;
          msg = error.message;

          if (error.code) {
            msg = i18next.t(`API_ERROR.${error.code}`);
            msg += `<br/><span className="error_code">${i18next.t(`API_ERROR.msg001`)}: ${error.code}</span>`
          }

          func = error?.func;
          break;
      }
      
      return ({
        ...state,
        errorMessage: msg,
        errorFunc: func,
        errorCode: error?.code,
        isDuplicate,
      })
    }
  },
  initialState
);

export default error;
